export { fetchPatientEncounters } from "./encounters-service";